import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
// Zod schema for API response transformation (snake_case -> camelCase)
export const reportTemplateSchema = z
    .object({
    id: z.string(),
    name: z.string(),
    report_type: z.string(),
    project_type: z.string(),
    location: z.string(),
    file_url: z.string(),
    file_name: z.string(),
    file_extension: z.string(),
    created_by: z.string(),
    created_by_username: z.string().optional(),
    updated_by: z.string().nullable().optional(),
    updated_by_username: z.string().nullable().optional(),
    created_at: z.string(),
    updated_at: z.string(),
})
    .strict()
    .transform(mapToCamelCase);
export const reportTemplateListSchema = z.object({
    count: z.number(),
    next: z.string().nullable(),
    previous: z.string().nullable(),
    results: z.array(reportTemplateSchema),
});
